var rsgbg = {
	init: function () {
		kitUtils.init();
		kitUtils.detectBrowserVendor();
		kitUtils.detectIEVersion();
		kitUtils.detectOS();
		rsgbg.flypanels();
		rsgbg.BetterXForms();
		rsgbg.tableWrapper();
		rsgbg.loadSimpleGMaps();
		rsgbg.imagebanner();
		rsgbg.topbanner();
		rsgbg.BetterForms();
		search.setUpdateAlarmsInterval();
		this.initTranslatePopup();
		setFocus.init();
	},

	socialjs: function () { 
		if ($('.socialjs').length > 0) {
			socialjs.init();
		}
	},
	initTranslatePopup: function () {
		$("#utilities-nav").on('click',
			'#btnTranslate',
			function (e) {
				e.preventDefault();
				$('#google_translate_element').detach().appendTo('#translate-popup');
				new google.translate.TranslateElement(
					{ pageLanguage: 'sv' },
					'google_translate_element'
				);
				$('#translate-popup').fadeIn('fast');

			});

		$("#utilities-nav").on('click',
			'.c-pop-out__close',
			function () {
				$(this).parent().fadeOut('fast');
			});

		$("html").on('click',
			'#main-content',
			function () {
				$('#translate-popup').fadeOut('fast');
			});

		$("#translate-item").on('click',
			'#btnMobileTranslate',
			function (e) {
				e.preventDefault();
				$('#google_translate_element').detach().appendTo('#mobile-translate');
				$('#mobile-translate').fadeToggle('fast');
				setTimeout(function () {
					new google.translate.TranslateElement(
						{ pageLanguage: 'sv' },
						'google_translate_element'
					);
				}, 100);


			});
	},
	linkListToSelect: function () {
		enquire.register('screen and (max-width: 991px)', {
			match: function () {
				$('.linklisttoselect').each(function () {
					var name = $(this).data('selectname');
					var sel = $('<select class="form-control generated ' + name + '">');
					$(this)
						.find('li')
						.each(function () {
							var isSelected = '';
							if ($(this).hasClass('active')) {
								isSelected = 'selected="selected"';
							}
							sel.append(
								$('<option ' + isSelected + '>')
									.attr('value', $(this).find('a').attr('href'))
									.text($(this).find('a').text())
							);
						});
					$(this).after(sel);
					$('.' + name).change(function () {
						window.location = $(this).find('option:selected').val();
					});
					$(this).hide();
				});
			},
			unmatch: function () {
				$('.linklisttoselect').each(function () {
					var name = $(this).data('selectname');
					$('.' + name).hide();
					$(this).show();
				});
			},
		});
	},

	imagebanner: function () {
		if ($('.block-imagebanner a p').length > 0) {
			$('.block-imagebanner a p').fitText(0.7, { minFontSize: '16px', maxFontSize: '50px' });
		}
	},

	topbanner: function () {
		var $topbanner = $('.startpage-topimage');
		if ($topbanner.length > 0) {
			rsgbg.setTopBannerHeight($topbanner);
			$(window).on('resize', function () {
				rsgbg.setTopBannerHeight($topbanner);
			});
		}
	},

	setTopBannerHeight: function ($topbanner) {
		$topbanner.css('height', $(window).width() * 0.31 + 'px');
	},

	isEpiserverEditMode: function () {
		if ($('html').attr('data-episerver') !== undefined) {
			if ($('html').data('episerver') === 'edit') {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	},

	flypanels: function () {
		kitUtils.log('flypanels: isEpiserverEditMode: ' + this.isEpiserverEditMode());
		if (!this.isEpiserverEditMode()) {
			flyPanels.init({
				treeMenu: {
					init: true,
					expandHandler: '.expand',
				},
				search: {
					init: true,
					saveQueryCookie: true,
				},
				onEmptySearchResult: function () {
					$(this).find('[data-panel="search"] .errormsg').hide();
				},
				onOpenLeft: function () {
					$(this).find('.panelcontent').attr('aria-expanded', 'true');
					$(this).find('.panelcontent a:first').focus();
				},
				onCloseLeft: function () {
					$(this).find('.panelcontent').attr('aria-expanded', 'false');
				},
				onOpenRight: function () {
					$(this).find('.search-input').focus();
					$(this).find('.panelcontent').attr('aria-expanded', 'true');
				},
				onCloseRight: function () {
					$(this).find('.panelcontent').attr('aria-expanded', 'false');
				},
			});
		}

		$('.flypanels-treemenu .expand').click(function () {
			var parent = this.parentElement.parentElement,
				submenu = parent.querySelector('.submenu');

			submenu.setAttribute('aria-expanded', parent.classList.contains('expanded') ? true : false);
		});
	},

	loadSimpleGMaps: function () {
		if ($('#simplegmap').length > 0) {
			simplegmaps.init({
				container: '#simplegmap',
			});
		}
	},

	BetterForms: function () {
		$('.FormChoice').each(function () {
			var $me = $(this),
				$radio = $me.find('.FormChoice__Input--Radio'),
				$checkbox = $me.find('.FormChoice__Input--Checkbox');

			$radio.parents('.FormChoice').addClass('FormChoice--Radio');
			$checkbox.parents('.FormChoice').addClass('FormChoice--Checkbox');
		});
	},

	BetterXForms: function () {
		$('.xform').BetterXforms({
			bsv: 3,
			iCheck: {
				enabled: true,
				labelHover: true,
				checkboxClass: 'icheckbox_square-blue',
				radioClass: 'iradio_square-blue',
				cursor: true,
			},
		});

		$('.EPiServerForms').prop('autocomplete', 'on');
	},

	tableWrapper: function () {
		$('.editorial')
			.find('table')
			.each(function () {
				$(this).wrap('<div class="table-wrapper" />');
			});
	},

	initRoyalslider: function () {
		kitUtils.log('slider: isEpiserverEditMode: ' + this.isEpiserverEditMode());
		if (!this.isEpiserverEditMode()) {
			$('.royalSlider').royalSlider({
				arrowsNav: true,
				loop: true,
				keyboardNavEnabled: true,
				controlsInside: false,
				imageScaleMode: 'fill',
				arrowsNavAutoHide: false,
				autoScaleSlider: true,
				autoScaleSliderWidth: 1920,
				autoScaleSliderHeight: 800,
				sliderDrag: false,
				controlNavigation: 'none',
				thumbsFitInViewport: false,
				navigateByClick: false,
				startSlideId: 0,
				autoPlay: false,
				transitionType: 'move',
				globalCaption: false,
				deeplinking: {
					enabled: true,
					change: false,
				},
				/* size of all images http://help.dimsemenov.com/kb/royalslider-jquery-plugin-faq/adding-width-and-height-properties-to-images */
				imgWidth: 1920,
				imgHeight: 800,
			});
		}
	},
};

jQuery(document).ready(function ($) {
	rsgbg.init();
});
